<generic-search-results
    [showHeader]="false"
    [showCounter]="false"
    [title]="''"
    [records]="displayCriteria"
    [displayedColumns]="criteriaDisplayColumns"
    [selectableRecords]="false"
    [allowLocalFilter]="false"
></generic-search-results>
<display-http-error [message]="errorMessage"></display-http-error>